import styles from "../../styles/Components/pricing-plan/Subscription.module.css";
import { useSearchParams } from "react-router-dom";
import PlanCard from "./new-plans/PlanCard";
import { useState } from "react";
import usePageTitle from "../../hooks/usePageTitle";
import SideMenu from "../../ui/SideMenu";
import PlanDurationSwitcher from "./new-plans/PlanDurationSwitcher";
import PlanPayment from "./new-plans/PlanPayment";
import { useSelector } from "react-redux";
import useFetchSubscription from "../../hooks/api/pricing-plan/useFetchSubscription";
import SubscriptionInfo from "./new-plans/SubscriptionInfo";
import { Spin } from "antd";
import useUserTier from "../../hooks/useUserTier";
import { FaLocationDot } from "react-icons/fa6";
import RegionalDiscountButton from "./regional-discount/RegionalDiscountButton";
import { AiOutlineInfoCircle } from "react-icons/ai";
import useSubscriptionPlans from "../../hooks/useSubscriptionPlans";
import PricingFaq from "./PricingFaq";

function Subscription() {
  const {
    ui: { sideMenuKey },
  } = useSelector((state) => state);

  const [expendedFeature, setExpendedFeature] = useState(["core"]);
  const [searchParams] = useSearchParams();
  const duration = searchParams.get("duration") || "annual";

  usePageTitle("Subscription");
  // const { loading } = useFetchSubscription();
  const { isVerified } = useUserTier();
  const { isLoading } = useSubscriptionPlans();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.titleWrapper}>
            <h4 className={styles.title}>Choose your plan</h4>
            {!isVerified && (
              <RegionalDiscountButton
                className={styles.discountBtn}
                icon={<FaLocationDot />}
              />
            )}
          </div>
        </div>
        <PlanDurationSwitcher
          style={{ alignSelf: "flex-end", marginLeft: "auto" }}
        />
      </div>

      {!isVerified && (
        <div className={styles.offerGuide}>
          <p>
            <AiOutlineInfoCircle size={16} style={{ marginRight: ".2rem" }} />
            If you're located in a lower-income country or eligible region, you
            may qualify for a significant discount.
            <br /> Click the "Regional Offer" button above to verify your
            location and unlock your discount.
          </p>
        </div>
      )}

      {isLoading && (
        <div className={styles.subscriptionLoader}>
          <Spin size="small" />
          <span>Checking your current subscription...</span>
        </div>
      )}
      <div className={styles.planList}>
        <PlanCard
          plan="Free Trial"
          handleExpand={setExpendedFeature}
          expandedFeature={expendedFeature}
        />
        <PlanCard
          plan="Lite"
          handleExpand={setExpendedFeature}
          expandedFeature={expendedFeature}
        />
        <PlanCard
          plan="Pro"
          handleExpand={setExpendedFeature}
          expandedFeature={expendedFeature}
        />
        <PlanCard
          plan="Enterprise"
          handleExpand={setExpendedFeature}
          expandedFeature={expendedFeature}
        />
      </div>

      {/*<div className={styles.footer}>*/}
      {/*  Pay your way - choose from credit card or crypto payments at checkout.*/}
      {/*</div>*/}

      <PricingFaq />

      <SideMenu
        title={`Take the next step to ${duration === "annual" ? "annual" : ""} ${sideMenuKey}`}
        scope="plan-checkout"
      >
        <PlanPayment plan={sideMenuKey} />
      </SideMenu>

      <SubscriptionInfo />
    </div>
  );
}

export default Subscription;
